<template>
    <div>
      <b-table :data="data.ifLignesEcritureAna" :bordered="true" :striped="true">
        <b-table-column field="libelle" :label="$t('ecritureCompta.tabHeader.libelle')"
                        v-slot="props">
          {{ props.row.libelle }}
        </b-table-column>
        <b-table-column field="compte" v-slot="props"
                        :label="$t('ecritureCompta.tabHeader.compteAnalytique')">
          {{ props.row.compte }}
        </b-table-column>
        <b-table-column field="debit" v-slot="props"
                        :label="$t('ecritureCompta.tabHeader.debit')">
          <div class="has-text-right">
            {{ props.row.debit | formatDevise }}
          </div>
        </b-table-column>
        <b-table-column field="credit" v-slot="props"
                        :label="$t('ecritureCompta.tabHeader.credit')">
          <div class="has-text-right">
            {{ props.row.credit | formatDevise }}
          </div>
        </b-table-column>
      </b-table>
    </div>
</template>

<script>

export default {
  props: {
    data: Object,
  },
};

</script>

<style scoped>

</style>
